<template>
    <!--
        FASE 4 / BLOCO AD — DOC 42, 84: o assinante EXTERNO, que não tem conta no sistema.

        Esta página resolve o convite pelo token e mostra o que a pessoa precisa saber.
        A assinatura em si depende de decisão pendente (ver relatório do bloco): assinante
        externo assinaria com certificado próprio, e receber `.pfx` de terceiro pelo
        navegador é decisão de segurança que não cabe ao código tomar sozinho.
    -->
    <div class="pagina-publica">
        <div class="cartao">
            <div v-if="carregando" class="u-text-center">
                <img src="/public/img/loading-bar.gif" />
            </div>

            <template v-else-if="convite">
                <h2>Documento para sua assinatura</h2>

                <table class="dados">
                    <tr><th>Convidado</th><td>{{ convite.nome }}</td></tr>
                    <tr><th>Documento</th><td>{{ convite.documento }}</td></tr>
                    <tr v-if="convite.natureza"><th>Natureza</th><td>{{ convite.natureza }}</td></tr>
                    <tr v-if="convite.data_limite">
                        <th>Prazo</th><td>{{ convite.data_limite | formatarData }}</td>
                    </tr>
                    <tr>
                        <th>Situação</th>
                        <td>
                            <span v-if="convite.situacao === 'assinado'" class="txt-ok">já assinado</span>
                            <span v-else-if="convite.situacao === 'recusado'" class="txt-falha">recusado</span>
                            <span v-else>aguardando sua assinatura</span>
                        </td>
                    </tr>
                </table>

                <div class="aviso" v-if="convite.situacao === 'pendente'">
                    <i class="el-icon-info"></i>
                    Para assinar, entre em contato com a instituição que enviou este convite.
                    A assinatura de participante externo é feita com acompanhamento, para
                    garantir que o certificado digital não trafegue por canal inseguro.
                </div>

                <div class="aviso" v-if="convite.codigo_verificacao">
                    Depois de concluído, o documento poderá ser conferido em
                    <router-link :to="'/verificar-assinatura/' + convite.codigo_verificacao">
                        verificar-assinatura/{{ convite.codigo_verificacao }}
                    </router-link>.
                </div>
            </template>

            <div v-else class="erro">
                <i class="el-icon-warning-outline"></i>
                <p>{{ mensagemErro }}</p>
            </div>
        </div>
    </div>
</template>
<script>

import moment from 'moment'

export default {
    filters: {
        formatarData (v) { return v ? moment(v).format('DD/MM/YYYY HH:mm') : '—' }
    },
    data: () => ({
        carregando: true,
        convite: null,
        mensagemErro: 'Convite inválido, expirado ou já utilizado.'
    }),
    mounted () {
        const token = this.$route.params.token

        this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/publico/assinatura/convite/${token}`)
            .then(r => { this.convite = r.data; this.carregando = false })
            .catch(e => {
                const d = e && e.response ? e.response.data : null
                if (d && typeof d.erro === 'string') this.mensagemErro = d.erro
                this.carregando = false
            })
    }
}
</script>
<style scoped>
.pagina-publica { min-height: 100vh; background: #F5F7FA; padding: 40px 15px; }
.cartao { max-width: 620px; margin: 0 auto; background: #fff; border-radius: 6px;
          box-shadow: 0 2px 12px rgba(0,0,0,.08); padding: 28px; }
h2 { margin: 0 0 16px; font-size: 19px; color: #303133; }
.dados { width: 100%; }
.dados th { text-align: left; width: 140px; color: #909399; font-weight: 500; padding: 6px 0; }
.dados td { padding: 6px 0; }
.txt-ok    { color: #67C23A; font-weight: 600; }
.txt-falha { color: #F56C6C; font-weight: 600; }
.aviso { margin-top: 18px; padding: 12px; background: #F4F4F5; border-radius: 4px;
         font-size: 13px; color: #606266; }
.erro { text-align: center; color: #F56C6C; padding: 30px 0; }
.erro i { font-size: 42px; display: block; margin-bottom: 12px; }
</style>
